/**
 * Created by Ning Jiang on 1/13/2020.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IScreenConfig} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {FreespinOutroController} from "@nolimitcity/slot-game/bin/game/screen/freespinoutro/FreespinOutroController";
import {TimelineLite} from "gsap";
import {DWBackground} from "../../background/DWBackground";
import {DeadwoodSoundConfig} from "../../DeadwoodSoundConfig";
import {DeadwoodGameMode} from "../../gamemode/DeadwoodGameMode";
import {DeadwoodMultiplierController} from "../../multiplier/DeadwoodMultiplierController";
import {FireParticles} from "../../particles/FireParticles";
import {DeadwoodParsedGameData} from "../../server/data/DeadwoodParsedGameData";
import {DeadwoodFreespinOutroView} from "./DeadwoodFreespinOutroView";
import {Deadwood} from "../../Deadwood";

export class DeadwoodFreespinOutroController extends FreespinOutroController {

    private _winRatio:number;

    constructor(config:IScreenConfig, tweakEnabled?:boolean) {
        super(config, tweakEnabled);
    }

    protected parseFeatureGameData(data:ParsedServerData):void {
        this._winRatio = (<ParsedGameData>data).currentWinRatio;
    }

    protected calculateIsTriggered(data:ParsedServerData):boolean {
        // return true;
        if(data.freespinsLeft !== 0) {
            return false;
        }

        return (data.mode === DeadwoodGameMode.FREESPIN_GUNSLINGER || data.mode === DeadwoodGameMode.FREESPIN_HUNTERS) && data.nextMode === GameMode.NORMAL;
    }

    protected show():boolean {
        const result:boolean = this.shouldShow();
        // #369
        (this._view as DeadwoodFreespinOutroView)._winBelowStake = (Deadwood.api.gameClientConfiguration.belowStakeWinRestriction && ((<DeadwoodParsedGameData>this._serverData).totalWin <= ((<DeadwoodParsedGameData>this._serverData).playedBetValue)));

        if(result) {
            const delay:number = this.getDelay();
            const timeline:TimelineLite = new TimelineLite();
            if (!(this._view as DeadwoodFreespinOutroView)._winBelowStake) { // #369
                timeline.add(() => SlotGame.sound.playEffect(DeadwoodSoundConfig.instance.FS_ENDS), delay - 0.751);
            }
            timeline.add(() => super.show(), delay);
        } else {
            super.show();
        }
        return result;
    }

    private getDelay():number {
        if(this._winRatio === 0) {
            return 0.8;
        }

        if(this._winRatio < 3) {
            return 1;
        }

        if(this._winRatio < 15) {
            return 1.5;
        }

        return 2.5;
    }

    protected doTransitions():void {
        EventHandler.dispatchEvent(new GameEvent(DWBackground.BURN_FRAME, false, 0.1));
        EventHandler.dispatchEvent(new GameEvent(DWBackground.DIM_STAGE, 0, 0.1));
        EventHandler.dispatchEvent(new GameEvent(DWBackground.FS_FIRE, false, true));
        EventHandler.dispatchEvent(new GameEvent(FireParticles.STOP));
        EventHandler.dispatchEvent(new GameEvent(DWBackground.BURN_BONUS_FRAME, false, false));
        EventHandler.dispatchEvent(new GameEvent(DeadwoodMultiplierController.HIDE_DAGGER));
        SlotGame.sound.playAmbience(DeadwoodSoundConfig.instance.MAIN_GAME_AMBIANCE);
    }
}